import { Box, Typography } from "@strapi/design-system";
import { Grid, GridItem } from "@strapi/design-system/Grid";
import React, { useEffect, useState } from "react";
import { DatePicker, message, Modal, Button } from "antd";
import { useTranslation } from "react-i18next";
import Sidebar from "./layout/Sidebar";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { getSetting, updateSetting } from "../util/API";
import { dateFormatList } from "../util/helper";

const CloseNomination = ({ lng = "vi" }) => {
  dayjs.extend(customParseFormat);
  const { t, i18n } = useTranslation();
  const [messageApi, contextHolder] = message.useMessage();
  const [closeDate, setCloseDate] = useState(null);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [closeNominationInfo, setCloseNominationInfo] = useState(null);
  const [closeNow, setCloseNow] = useState(false);

  useEffect(() => {
    getSettingInfo();
  }, []);

  useEffect(() => {
    if (lng) {
      i18n.changeLanguage(lng);
    }
  }, [lng]);

  const handleSetDate = (date, dateString) => {
    setCloseDate(dayjs(date).format(dateFormatList[1]));
  };

  const handleShowConfirm = () => {
    if (!closeDate || closeDate === null || closeDate === "") {
      messageApi.open({
        type: "error",
        content: "Vui lòng chọn ngày đóng đề cử",
      });
    } else {
      setCloseNow(false);
      setOpenConfirm(true);
    }
  };

  const handleCloseNow = () => {
    setCloseNow(true);
    setOpenConfirm(true);
  };

  const handleConfirmClose = async (withMail = false) => {
    const params = {
      close_nominations: {
        type: closeNow === true ? "now" : "future", // open, now (đóng ngay lập tức), future (đóng trong tương lai
        close_at: closeNow === true ? null : closeDate, // thời gian đóng lúc nào nếu type == future
        send_notification: withMail, //có gửi mail hay không
      },
    };

    try {
      const response = await updateSetting(closeNominationInfo?.id, params);

      if (response.status === 200) {
        messageApi.open({
          type: "success",
          content: "Cập nhật ngày đóng đề cử thành công.",
        });

        setOpenConfirm(false);
      }
    } catch (err) { }
  };

  const handleSetCloseDate = (str_date) => {
    const date = new Date(str_date) || new Date();
    const yyyy = date.getFullYear();
    let mm = date.getMonth() + 1;
    let dd = date.getDate();

    if (dd < 10) dd = "0" + dd;
    if (mm < 10) mm = "0" + mm;

    const formattedToday = yyyy + "-" + mm + "-" + dd;

    setCloseDate(formattedToday);
  }

  const getSettingInfo = async () => {
    try {
      const response = await getSetting();
      if (response.status === 200) {
        const data = response.data?.data;
        const item = data.find(
          (x) => x.attributes.name === "close_nominations"
        );

        handleSetCloseDate(item.attributes.value.close_at)
        if (item) setCloseNominationInfo(item);
      }
    } catch (err) {
        handleSetCloseDate(null)
    }
  };

  return (
    <div>
      {contextHolder}
      <div>
        <div className="main-wrapper">
          <Sidebar role={{ type: "secretariat" }} key={"close_nomination"} />

          <div className="main-panel-lg">
            <Box padding={4}>
              <Grid gridCols={3} gap={5}>
                <GridItem col={1} s={12} xs={12}>
                  <Typography variant="pi" fontWeight="bold">
                    {t("str_date_of_closing")}
                  </Typography>
                  <br />
                  <DatePicker
                    placeholder="dd/mm/yyyy"
                    className="custom-date-picker"
                    onChange={handleSetDate}
                    value={closeDate ? dayjs(closeDate, dateFormatList[1]) : null}
                    format={dateFormatList[0]}
                  />
                </GridItem>

                <div className="custom-box">
                  <Button className="btnSave" onClick={handleShowConfirm}>
                    {t("str_confirm")}
                  </Button>
                </div>

                <GridItem col={3} s={12} xs={12}>
                  <Typography variant="pi" fontWeight="bold">
                    {t("str_or")}
                  </Typography>
                </GridItem>

                <GridItem col={1} s={12} xs={12}>
                  <Button className="btnSave" onClick={handleCloseNow}>
                    {t("str_closed_now")}
                  </Button>
                </GridItem>
              </Grid>
            </Box>
          </div>
        </div>
      </div>

      <Modal
        open={openConfirm}
        title={t("str_confirm")}
        onOk={() => { }}
        onCancel={() => setOpenConfirm(false)}
        centered
        footer={
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button key="back" onClick={() => setOpenConfirm(false)}>
              Hủy bỏ
            </Button>

            <Button
              key="submit"
              onClick={() => handleConfirmClose(false)}
              className="btnSave"
              style={{ marginLeft: "10px" }}
            >
              {t("str_confirm")}
            </Button>

            <Button
              key="submit"
              onClick={() => handleConfirmClose(true)}
              className="btnSave"
            >
              {t("str_confirm_and_send_mail")}
            </Button>
          </div>
        }
      >
        <p>Bạn có chắc chắn muốn đóng đề cử ?</p>
      </Modal>
    </div>
  );
};

export default CloseNomination;
